export const DENTIST_INDUSTRY_VALUE = 'Dentists';

const DENTIST_INDUSTRY_PATTERN = /\b(dentist|dentists|dental|dental clinic|dental clinics)\b/i;

export function canonicalizeIndustryValue(value) {
  const normalized = String(value || '').trim();
  if (!normalized) return '';
  if (DENTIST_INDUSTRY_PATTERN.test(normalized)) return DENTIST_INDUSTRY_VALUE;
  return normalized;
}

export function canonicalizeIndustryValues(values = []) {
  const seen = new Set();
  const canonicalized = [];

  for (const value of values) {
    const normalized = canonicalizeIndustryValue(value);
    if (!normalized) continue;
    const dedupeKey = normalized.toLowerCase();
    if (seen.has(dedupeKey)) continue;
    seen.add(dedupeKey);
    canonicalized.push(normalized);
  }

  return canonicalized;
}
